

import React from 'react';
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    Linking,
    StyleSheet,
    Text,
    useWindowDimensions,
    ScrollView,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const data = [
    { id: '1', image: 'https://cdn.imogo.com.br/img/evento-trilha/13.png', locked: false, unlockDate: '25/02 às 9h', link: 'https://juk.re/live-25-02' }, // Bloqueado com data e hora
    { id: '2', image: 'https://cdn.imogo.com.br/img/evento-trilha/10.png', locked: false, unlockDate: '01/04 às 9h', link: 'https://juk.re/live-01-04' }, // Bloqueado com data e hora
    { id: '3', image: 'https://cdn.imogo.com.br/img/evento-trilha/11.png', locked: false, unlockDate: '30/04 às 9h', link: 'https://juk.re/live-30-04' },
    { id: '4', image: 'https://cdn.imogo.com.br/img/evento-trilha/12.png', locked: false, unlockDate: '29/05 às 9h', link: 'https://juk.re/live-29-05' },
    { id: '5', image: 'https://cdn.imogo.com.br/img/evento-trilha/14.png', locked: false, unlockDate: '24/06 às 9h', link: 'https://juk.re/live-24-06' },
];

const CardItem = ({ item }) => (
    <TouchableOpacity
        style={styles.card}
        onPress={() => !item.locked && Linking.openURL(item.link)}
        activeOpacity={item.locked ? 1 : 0.7}
    >
        <Image source={{ uri: item.image }} style={styles.image} />
        {item.locked && (
            <View style={styles.lockOverlay}>
                <Ionicons name="lock-closed-outline" size={40} color="white" />
                {item.unlockDate && (
                    <Text style={styles.unlockDateText}>{item.unlockDate}</Text>
                )}
            </View>
        )}
    </TouchableOpacity>
);

export default function CardGrid() {
    return (
        <ScrollView contentContainerStyle={styles.container}>
            <View style={styles.grid}>
                {data.map((item) => (
                    <CardItem key={item.id} item={item} />
                ))}
            </View>
        </ScrollView>
    );
}

const styles = StyleSheet.create({
    container: {
        padding: 20,
        alignItems: 'center',
        backgroundColor: '#f5f5f5',
    },
    title: {
        fontSize: 20,
        fontWeight: '600',
        marginBottom: 20,
        alignSelf: 'flex-start',
    },
    card: {
        width: 260,               // Largura ideal fixa
        height: 360,              // Altura proporcional para vídeos
        margin: 10,
        borderRadius: 12,
        overflow: 'hidden',
        backgroundColor: '#FFF',
        elevation: 3,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.2,
        shadowRadius: 4,
    },

    // E atualize o grid com wrap e centralização:
    grid: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',  // Centraliza os cards
        width: '100%',
    },
    image: {
        width: '100%',
        height: '100%',
        resizeMode: 'cover',
    },
    lockOverlay: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 10,
    },
    unlockDateText: {
        color: 'white',
        fontSize: 14,
        fontWeight: 'bold',
        marginTop: 8,
        textAlign: 'center',
    },
});
